import { render } from "./Error404Page.vue?vue&type=template&id=896b9be6&scoped=true"
import script from "./Error404Page.vue?vue&type=script&lang=js"
export * from "./Error404Page.vue?vue&type=script&lang=js"

import "./Error404Page.vue?vue&type=style&index=0&id=896b9be6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896b9be6"]])

export default __exports__